(function (angular) {
    angular.module('app.sgdpppurchase').config([
        '$stateProvider',
        '$urlRouterProvider',
        function ($stateProvider, $urlRouterProvider) {
            $stateProvider
                .state('app.sgdpppurchase', {
                    url: '/plansplus',
                    abstract: true,
                    templateUrl: '/app/site/purchase-flow/purchase-flow-sgdpp.template.html',
                    controller: 'app.sgdpppurchase.PurchaseFlowController',
                    controllerAs: 'vmPurchaseFlow'
                })
                .state('app.sgdpppurchase.plans', {
                    url: '',
                    templateUrl: '/app/site/purchase-flow/choose-plan/choose-plan.html',
                    controller: 'app.purchase.ChoosePlanController',
                    controllerAs: 'vm'
                })
                .state('app.sgdpppurchase.applicants', {
                    url: '/application',
                    templateUrl: '/app/site/purchase-flow/applicant-info/applicant-info.template.html',
                    controller: 'app.purchase.ApplicantInfoController',
                    controllerAs: 'vm',
                    resolve: {
                        purchase: [
                            'app.purchase.purchaseFlowService',
                            '$state',
                            'ui',
                            function (purchaseFlowService, $state, ui) {
                                ui.block();
                                return purchaseFlowService
                                    .getPurchase()
                                    .then(function (purchase) {
                                        if (!purchase.coverageLevelName) {
                                            setTimeout(function () {
                                                $state.go('app.sgdpppurchase.plans');
                                            });
                                            throw 'A plan must be selected first.';
                                        }
                                        return purchase;
                                    })
                                    .finally(function () {
                                        ui.unblock();
                                    });
                            }
                        ]
                    }
                })
                .state('app.sgdpppurchase.responsibleParty', {
                    url: '/application',
                    templateUrl: '/app/site/purchase-flow/responsible-party-info/responsible-party-info.template.html',
                    controller: 'app.purchase.ResponsiblePartyInfoController',
                    controllerAs: 'vm',
                    resolve: {
                        purchase: [
                            'app.purchase.purchaseFlowService',
                            '$state',
                            'ui',
                            function (purchaseFlowService, $state, ui) {
                                ui.block();
                                return purchaseFlowService
                                    .getPurchase()
                                    .then(function (purchase) {
                                        if (!purchase.coverageLevelName) {
                                            setTimeout(function () {
                                                $state.go('app.sgdpppurchase.plans');
                                            });
                                            throw 'A plan must be selected first.';
                                        }
                                        return purchase;
                                    })
                                    .finally(function () {
                                        ui.unblock();
                                    });
                            }
                        ]
                    }
                })
                .state('app.sgdpppurchase.payment', {
                    url: '/payment',
                    templateUrl: '/app/site/purchase-flow/payment-info/payment-info.template.html',
                    controller: 'app.purchase.PaymentInfoController',
                    controllerAs: 'vm',
                    resolve: {
                        purchase: [
                            'app.purchase.purchaseFlowService',
                            '$state',
                            'ui',
                            function (purchaseFlowService, $state, ui) {
                                ui.block();
                                return purchaseFlowService
                                    .getPurchase()
                                    .then(function (data) {
                                        try {
                                            if (!data.coverageLevelName) {
                                                throw 'A plan must be selected first.';
                                            }
                                            if (!data.primaryApplicant) {
                                                throw 'An applicant must be entered first.';
                                            }

                                            var numMembers = 1;
                                            if (data.associatedApplicants) {
                                                numMembers += data.associatedApplicants.length;
                                            }

                                            if (data.minNumberMembers > numMembers) {
                                                throw 'This plan requires associated applicants to be entered first.';
                                            }

                                            data.paymentInfo = null;
                                            return data;
                                        } catch (e) {
                                            setTimeout(function () {
                                                $state.go('app.sgdpppurchase.applicants');
                                            });
                                            throw e;
                                        }
                                    })
                                    .finally(function () {
                                        ui.unblock();
                                    });
                            }
                        ]
                    }
                })
                .state('app.sgdpppurchase.activated', {
                    url: '/activated',
                    templateUrl: '/app/site/purchase-flow/activated/activated.template.html',
                    controller: 'app.purchase.activatedController',
                    controllerAs: 'vm',
                    resolve: {
                        purchase: [
                            'app.purchase.purchaseFlowService',
                            '$state',
                            'ui',
                            function (purchaseFlowService, $state, ui) {
                                ui.block();
                                return purchaseFlowService
                                    .getPurchase(true)
                                    .then(function (purchase) {
                                        if (!purchase.completed || typeof purchase.completed == 'undefined' || purchase.completed == null) {
                                            setTimeout(function () {
                                                $state.go('app.sgdpppurchase.plans');
                                            });
                                            throw 'A plan must be complete.';
                                        }
                                        else if (!purchase.coverageLevelName) {
                                            setTimeout(function () {
                                                $state.go('app.sgdpppurchase.plans');
                                            });
                                            throw 'A plan must be selected first.';
                                        }
                                        return purchase;
                                    })
                                    .finally(function () {
                                        ui.unblock();
                                    });
                            }
                        ]
                    },
                    isShowProgressbar: false
                });

                function goToCurrentOrDefault($state) {
                    if (!$state.current.name) {
                        $state.go('app.sgdpppurchase.plans');
                    } else {
                        $state.go($state.current.name);
                    }
                }
        }
    ]);
})(angular);

